import { render, staticRenderFns } from "./pentagon.vue?vue&type=template&id=f7bffaca&scoped=true"
import script from "./pentagon.vue?vue&type=script&lang=js"
export * from "./pentagon.vue?vue&type=script&lang=js"
import style0 from "./pentagon.vue?vue&type=style&index=0&id=f7bffaca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7bffaca",
  null
  
)

export default component.exports